// jve-2-4: the access token lives in a module-private variable — never in localStorage or
// sessionStorage (AC2). A bundle-scoped variable is cleared on reload, which is exactly the
// in-memory lifetime an OAuth2 public client should have; a fresh PKCE flow re-mints it.
let accessToken: string | undefined;

export function getAccessToken(): string | undefined {
  return accessToken;
}

export function setAccessToken(token: string | undefined): void {
  accessToken = token;
}

export function clearAccessToken(): void {
  accessToken = undefined;
}
